import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'
import { isMeinBuero } from '@/utils/build-env'

const isMeinbuero = isMeinBuero()

export const trackOrgamaxGaEvent = (eventCategory = '', eventAction = '', eventLabel = '') => {
  if (isMeinbuero) return

  GtmService.pushEvent({
    event: GtmEventTypes.GaEventHub,
    eventCategory,
    eventAction,
    eventLabel,
  })
}
